// hamburger.js
document.addEventListener('DOMContentLoaded', () => {
  const btn   = document.querySelector('[data-menu-toggle]');
  const panel = document.querySelector('[data-menu-panel]');
  if (!btn || !panel) return;

  if (btn.__hbBound) return;
  btn.__hbBound = true;

  const HTML_OPEN_CLASS = 'is-menu-open';
  const BODY_FIXED_CLASS = 'is-fixed';
  const PC_QUERY = '(min-width: 1024px)';

  const isOpen = () => btn.getAttribute('aria-expanded') === 'true';

  const setOpen = (open) => {
    btn.setAttribute('aria-expanded', String(open));
    btn.setAttribute('aria-label', open ? 'メニューを閉じる' : 'メニューを開く');
    panel.classList.toggle('is-open', open);
    document.documentElement.classList.toggle(HTML_OPEN_CLASS, open);
    document.body.classList.toggle(BODY_FIXED_CLASS, open);
    if (open) {
      const first = panel.querySelector('a,button,[tabindex]:not([tabindex="-1"])');
      if (first) first.focus({ preventScroll: true });
    } else {
      btn.focus({ preventScroll: true });
    }
  };

  btn.addEventListener('click', (e) => {
    e.preventDefault();
    setOpen(!isOpen());
  });

  panel.addEventListener('click', (e) => {
    if (e.target.closest('a')) setOpen(false);
  });

  document.addEventListener('click', (e) => {
    if (!isOpen()) return;
    if (!panel.contains(e.target) && !btn.contains(e.target)) setOpen(false);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isOpen()) setOpen(false);
  });

  const mql = window.matchMedia(PC_QUERY);
  const handleMQ = () => { if (mql.matches) setOpen(false); };
  mql.addEventListener ? mql.addEventListener('change', handleMQ) : mql.addListener(handleMQ);
  handleMQ();

  window.addEventListener('pageshow', () => setOpen(false));
});

/* ===========================================================
   WPセーフ版：アンカー → ScrollTrigger.start にピタ止め
   + メニュー自動クローズ（遷移前に確実に閉じてから計算）
=========================================================== */
(() => {
  if (document.__anchorBoundWP) return;
  document.__anchorBoundWP = true;

  const hasST = () => typeof window.ScrollTrigger !== "undefined";

  const normPath = (p) => {
    let s = p || "/";
    if (s.endsWith("/index.php")) s = s.slice(0, -10);
    if (!s.endsWith("/")) s += "/";
    return s;
  };

  function closeMenuIfOpenAndGetWait() {
    const btn   = document.querySelector('[data-menu-toggle]');
    const panel = document.querySelector('[data-menu-panel]');
    if (!btn || !panel) return 0;

    const isOpen = btn.getAttribute('aria-expanded') === 'true';
    if (!isOpen) return 0;

    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', 'メニューを開く');
    panel.classList.remove('is-open');
    document.documentElement.classList.remove('is-menu-open');
    document.body.classList.remove('is-fixed');

    const cs = getComputedStyle(panel);
    const durs = cs.transitionDuration.split(',').map(s => parseFloat(s) || 0);
    const dels = cs.transitionDelay.split(',').map(s => parseFloat(s) || 0);
    const maxSec = Math.max(
      0,
      ...durs.map((d, i) => d + (dels[i] || 0))
    );
    return Math.round(maxSec * 1000) + 20;
  }

  const findBase = (el) => {
    const base = el.closest?.("[data-pin-offset-ratio]") || el;
    const raw  = base?.getAttribute?.("data-pin-offset-ratio") || "0.025";
    const n    = parseFloat(raw);
    return { base, ratio: Number.isFinite(n) ? n : 0.025 };
  };

  const findST = (base) => {
    if (!hasST() || !base) return null;
    const list = window.ScrollTrigger.getAll();
    return (
      list.find(s => s?.vars?.pin && (s?.vars?.trigger === base || s?.vars?.trigger?.contains?.(base))) ||
      list.find(s => s?.vars?.trigger === base || s?.vars?.trigger?.contains?.(base)) ||
      null
    );
  };

  const getScroller = (st) => {
    if (!st) return window;
    const sc = st.scroller || window;
    return (sc === document.body || sc === document.documentElement) ? window : sc;
  };

  const computeY = (base, ratio, st) => {
    if (st) return st.start;
    const top = base.getBoundingClientRect().top + window.pageYOffset;
    return top + base.offsetHeight * ratio;
  };

  function disableNativeSmoothTemporarily() {
    const el = document.documentElement;
    const prev = el.style.scrollBehavior;
    el.style.scrollBehavior = "auto";
    return () => { el.style.scrollBehavior = prev; };
  }

  function settle(extraWaitMs, cb) {
    const restore = disableNativeSmoothTemporarily();
    setTimeout(() => {
      requestAnimationFrame(() => {
        if (hasST()) window.ScrollTrigger.refresh();
        requestAnimationFrame(() => { restore(); cb(); });
      });
    }, Math.max(0, extraWaitMs || 0));
  }

  function goToHash(hash, smooth) {
    const target = document.querySelector(hash);
    if (!target) return;

    const { base, ratio } = findBase(target);

    const waitMs = closeMenuIfOpenAndGetWait();

    settle(waitMs, () => {
      const st = findST(base);
      const scroller = getScroller(st);
      const y = computeY(base, ratio, st);

      if (history.replaceState) history.replaceState(null, "", hash);
      if (scroller === window) {
        window.scrollTo({ top: y, behavior: smooth ? "smooth" : "auto" });
      } else {
        scroller.scrollTo({ top: y, behavior: smooth ? "smooth" : "auto" });
      }

      setTimeout(() => {
        if (hasST()) window.ScrollTrigger.refresh();
        const st2 = findST(base);
        const y2 = computeY(base, ratio, st2);
        const cur = scroller === window ? window.pageYOffset : scroller.scrollTop;
        if (Math.abs(cur - y2) > 1) {
          if (scroller === window) window.scrollTo({ top: y2, behavior: "auto" });
          else scroller.scrollTo({ top: y2, behavior: "auto" });
        }
      }, 180);
    });
  }

  document.addEventListener("click", (e) => {
    const a = e.target.closest('a[href*="#"]');
    if (!a) return;

    let u; try { u = new URL(a.getAttribute("href") || "", location.href); } catch { return; }
    if (!u.hash) return;
    if (u.origin !== location.origin) return;
    if (normPath(u.pathname) !== normPath(location.pathname)) return;

    e.preventDefault();
    e.stopPropagation();
    goToHash(u.hash, true);
  }, true);

  function jumpIfHash() { if (location.hash) goToHash(location.hash, false); }
  if (document.readyState === "complete") setTimeout(jumpIfHash, 0);
  else window.addEventListener("load", () => setTimeout(jumpIfHash, 0), { once: true });
  window.addEventListener("pageshow", (ev) => { if (ev.persisted) setTimeout(jumpIfHash, 0); });
})();
